import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../../..//app.service';
import { OrdinalDateAdapter, ORD_DATE_FORMATS } from '../../adapters/ordinal-date-adapter';
import { ImplementInspectionImageViewModel, PhotoModelComingFrom } from '../../inspections/inspection.model';
import { GETViewPhotoComponent } from '../../shared/view-photo/view-photo.component';
import { FecrAddNewPrepostShipmentObservationComponent } from '../fecr-add-new-prepost-shipment-observation/fecr-add-new-prepost-shipment-observation.component';
import { FECRAdditionalObsVM, FECRInspectionAdditionalObsVM, FECRPrePostAdditionalObsVM, ImageList } from '../FECRDashboard/fecr-search-panel/fecr-search-panel.model';
import { FrontEndComponetService } from '../front-end-componet.service';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-fecr-new-pre-post-shipment-inspection',
  templateUrl: './fecr-new-pre-post-shipment-inspection.component.html',
  styleUrls: ['./fecr-new-pre-post-shipment-inspection.component.scss'],
  providers: [
    {
        provide: DateAdapter, useClass: OrdinalDateAdapter
    },
    {
        provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
    }
]
})
export class FecrNewPrePostShipmentInspectionComponent implements OnInit {
  FECRInspectionInfo:FECRInspectionAdditionalObsVM;
  observationLists:FECRPrePostAdditionalObsVM[];
implementId:number;
inspectionId:number;
eventDate:Date= new Date();
maxDateForAction: Date = new Date();
selectedInspectionType:number;
inspectionImages:PhotoModelComingFrom;
  constructor(private _route: ActivatedRoute,private _dialog: MatDialog,
    private _notification: NotificationsService,private _sanitizer: DomSanitizer, 
    private _fecrService: FrontEndComponetService,private _appService: AppService,) { }

  ngOnInit() {
    this._appService.setPageTitle('CRC Pre-Post Inspection');
    this.implementId = +this._route.snapshot.paramMap.get('implementId');
    this.inspectionId = +this._route.snapshot.paramMap.get('inspectionId');
    this.inspectionImages=PhotoModelComingFrom.FECRAdditionalObs;
    if(this.inspectionId>0){
      this.HideCreateInspection=true;
      this.loadImplementTypeAddtionalObservationList();
    }


  }
  
  HideCreateInspection:boolean=false;
  loadImplementTypeAddtionalObservationList(){
    this._fecrService.GetFECRPrePostInspection(this.implementId,this.inspectionId).subscribe(res=>{
      this.FECRInspectionInfo = res;
      this.observationLists = this.FECRInspectionInfo.AdditionalObsPoints;
      this.selectedInspectionType = this.FECRInspectionInfo.InspectionTypeId;
      this.eventDate = this.FECRInspectionInfo.CreatedDate;
    })
  }
  CreateNewFECRInspection(){

    if(this.selectedInspectionType>0 && this.selectedInspectionType!=null){
      let model =  new FECRInspectionAdditionalObsVM();
      model.ImplementId = this.implementId;
      model.CreatedDate = this.eventDate;
      model.InspectionTypeId =this.selectedInspectionType;
      
      this._fecrService.AddNewFECRPrePostInspection(model).subscribe(res=>{
        this.FECRInspectionInfo = res;
        this.inspectionId = res.InspectionId;
  
        if(this.inspectionId>0){
          this.HideCreateInspection=true;
        }
        this.observationLists = res.AdditionalObsPoints;
        
      })
    }else{
      this._notification.error("Please select an Inspection Type from the drop down")
    }

  }

  updateComment(comment:string, Id:number, model:FECRPrePostAdditionalObsVM){
 
    this._fecrService.UpdateFECRAdditionaObsComment(model).subscribe(res=>{
      if(res.m_Item1){
        this._notification.success("Successfully Saved Comment")
      }else{
        this._notification.error("Unable to save Comment")
      }
    })
  }

  AddNewObservationList() {

    const dialogRef = this._dialog.open(FecrAddNewPrepostShipmentObservationComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        //selectedCustomer: this.selectedCustomer
        isEditing:false,
        InspectionId:this.inspectionId,
        isInspectionEdit:true,
      }
    });

    dialogRef.afterClosed().subscribe(addedCustomer => {
      if (addedCustomer) {
        this._notification.success("Successfully Added")
        this.loadImplementTypeAddtionalObservationList();
      }
    });
   }

   EditObservation(model:FECRPrePostAdditionalObsVM){
    const dialogRef = this._dialog.open(FecrAddNewPrepostShipmentObservationComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        //selectedCustomer: this.selectedCustomer
        isEditing:true,
        Title:model.Title,
        InspectionId:this.inspectionId,
        isInspectionEdit:true,
        ObsId:model.Id,
      }
    });

    dialogRef.afterClosed().subscribe(addedCustomer => {
      if (addedCustomer) {
        this._notification.success("Successfully Updated")
        this.loadImplementTypeAddtionalObservationList();
      }
    });
   }

   getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }

  
  ViewInspectionImage(data:FECRPrePostAdditionalObsVM,img: ImageList) {
    const passingData =  {
      comingFrom: PhotoModelComingFrom.FECRAdditionalObs,
      image: img,
      FECRAdditonalObsId:data.Id,
    };
    const viewInspectionPhoto = this._dialog.open(GETViewPhotoComponent, {
      width: '1032px',
      data: passingData,
    });
    viewInspectionPhoto.afterClosed().subscribe(changes => {
      if (changes) {
        this.loadImplementTypeAddtionalObservationList();
      }
    });
}

photoRecevied(image, obj: FECRPrePostAdditionalObsVM) {
  console.log("Data", image,obj)
   var imageview = new ImageList();
   imageview.Image=image.Image;
   imageview.Id = image.Id;
   if (obj.Images !== undefined && obj.Images!=null && obj.Images.length>0) {
    obj.Images.push(imageview);
   }    else {
    obj.Images = [];
    obj.Images.push(imageview);
   }
 }

 OpenDeleteAdditionalObs(obId:number){
   this._fecrService.DeletFECRInspectionObsPoint(obId).subscribe(res=>{
     if(res){
       this.loadImplementTypeAddtionalObservationList();
       this._notification.success("Sucessfully Deleted ")
     }else{
     
      this._notification.error("Unable to Delete the Point ")
     }
   })
 }

}
